import React__default from 'react';
import { useFloating, offset, flip, shift, autoUpdate, useHover, safePolygon, useFocus, useClick, useDismiss, useRole, useInteractions } from '@floating-ui/react';

const isTest = process.env.NODE_ENV === "test";
const defaultDelay = isTest ? [
    0,
    0
] : [
    160,
    0
];
const defaultOffset = 5;
const defaultPlacement = "top";
function useTooltip({ delay = defaultDelay, interactive, offset: offset$1 = defaultOffset, onHide, onOpen: setControlledOpen, placement = defaultPlacement, visible: controlledOpen }) {
    const [uncontrolledOpen, setUncontrolledOpen] = React__default.useState(false);
    const open = controlledOpen !== null && controlledOpen !== void 0 ? controlledOpen : uncontrolledOpen;
    const setOpen = setControlledOpen !== null && setControlledOpen !== void 0 ? setControlledOpen : setUncontrolledOpen;
    const data = useFloating({
        placement,
        open,
        onOpenChange: (value)=>{
            setOpen(value);
            if (!value && onHide) {
                onHide();
            }
        },
        whileElementsMounted: autoUpdate,
        middleware: [
            offset(offset$1),
            flip({
                fallbackAxisSideDirection: "start"
            }),
            shift()
        ]
    });
    const context = data.context;
    const hover = useHover(context, {
        move: true,
        delay: delay ? {
            open: delay[0],
            close: delay[1]
        } : undefined,
        enabled: controlledOpen == null,
        handleClose: interactive ? safePolygon({
            requireIntent: true
        }) : null
    });
    const focus = useFocus(context, {
        enabled: controlledOpen == null
    });
    const click = useClick(context);
    const dismiss = useDismiss(context);
    const role = useRole(context, {
        role: "tooltip"
    });
    const interactions = useInteractions([
        hover,
        focus,
        dismiss,
        role,
        click
    ]);
    return React__default.useMemo(()=>({
            open,
            setOpen,
            ...interactions,
            ...data
        }), [
        open,
        setOpen,
        interactions,
        data
    ]);
}
const TooltipContext = /*#__PURE__*/ React__default.createContext(null);
const useTooltipContext = ()=>{
    const context = React__default.useContext(TooltipContext);
    if (context == null) {
        throw new Error("Tooltip components must be wrapped in <Tooltip.Root />");
    }
    return context;
};

export { TooltipContext, useTooltip, useTooltipContext };
